enum ErrorMessage {
  DK001BankDocumentNotEqualError = 'bankDocumentNotEqual',
  DK002BankDataValidationError = 'bankSaveError',
  DK003ExternalAPIRequestError = 'bankSaveError',
  DK004ExternalAPIValidationError = 'bankSaveError',
  DK005BankFieldsEditTemporarilyNotAllowedError = 'blockedFields',
}

export default ErrorMessage
